import { gql } from "@apollo/client";

const AGREGAR_USUARIOS_RESPONSABLE = gql`
    mutation agregarUsuariosResponsable($input: [AddUsuarioResponsableAreaInput!]!){
        agregarUsuariosResponsable(input: $input) {
            id
        }
    }
`;

export default AGREGAR_USUARIOS_RESPONSABLE;